import { render, staticRenderFns } from "./iristarSoftware.vue?vue&type=template&id=2264816e&"
import script from "./iristarSoftware.vue?vue&type=script&lang=js&"
export * from "./iristarSoftware.vue?vue&type=script&lang=js&"
import style0 from "./iristarSoftware.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports